<template>
  <b-container>
    <h1>{{ $t("fuelConsumptionTarget.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <FuelConsumptionTargetCrud
          ref="crudData"
          :model="model"
          :modelstate="modelstate"
        />
      </b-col>
    </b-row>

    <!-- {{ model }} -->
    <b-button @click="save()" type="submit" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </b-container>
</template>
  <script>
export default {
  name: "FuelConsumptionTargetCreate",
  components: {
    FuelConsumptionTargetCrud: () =>
      import(
        "@/components_rms/fuelSupplies/fuelConsumptionTarget/FuelConsumptionTargetCrud.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  computed: {
    getUrlBackToList() {
      return `../fuelConsumptionTarget/list`;
    },
  },
  data() {
    return {
      alert: {
        error: "",
        success: this.$t("fuelConsumptionTarget.createSuccess"),
      },
      submitted: false,
      model: {
        vehicleModelId: "",
        vehicleId: null,
        beginAt: null,
        endAt: null,
        weightBegin: "0,00",
        weightEnd: "0,00",
        consumptionTarget: "0,00",
        originChecklistId: "",
        fuelSupplyChecklistId: "",
        fuelSupplyId: "",
        markerType: null,
      },
      modelstate: {},
    };
  },
  methods: {
    save() {
      this.submitted = true;
      console.log(this.model);
      this.$apiVehicle
        .post("/fuelConsumptionTarget/create/", this.model)
        .then((response) => {
          this.modelstate = {};
          this.cleanModel();
          this.submitted = false;
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
    cleanModel() {
      this.model = {
        vehicleModelId: "",
        vehicleId: null,
        beginAt: null,
        endAt: null,
        weightBegin: "0,00",
        weightEnd: "0,00",
        consumptionTarget: "0,00",
        originChecklistId: "",
        fuelSupplyChecklistId: "",
        fuelSupplyId: "",
        markerType: null,
      };
    },
  },
};
</script>
  